import React from "react";
import { Helmet } from "react-helmet-async";
import "./About.css";
import { Link } from "react-router-dom";

import { 
FaChevronDown
} from "react-icons/fa";


import aboutHeroBg from "../assets/about-after-hero1.jpeg";
import aboutWhoImg from "../assets/about-after-hero1.jpeg";



const About = () => {
  return (
    <>
      {/* SEO */}
      <Helmet>
        <title>
          Digital Marketing Experts in Nairobi | Satima Technova Solutions
        </title>

        <link rel="canonical" href="https://satimatechnova.co.ke/about/" />

        <meta
          name="description"
          content="Meet Satima Technova Solutions, a team of experienced digital marketing experts and consultants in Nairobi helping businesses grow through strategy, technology, and measurable results."
        />

        <meta
          name="keywords"
          content="digital marketing company Nairobi, digital marketing experts Nairobi, marketing consultants Nairobi, business growth experts Nairobi, digital growth agency Nairobi"
        />

        <meta name="author" content="Satima Technova" />

        {/* Open Graph */}
        <meta property="og:title" content="Digital Marketing Experts in Nairobi" />
        <meta
          property="og:description"
          content="A trusted team of digital marketing experts in Nairobi helping businesses achieve real growth through proven strategies and systems."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://satimatechnova.co.ke/about/" />


{/* =========================================================
    ABOUT PAGE FAQ SCHEMA
========================================================= */}

<script
  type="application/ld+json"
  dangerouslySetInnerHTML={{
    __html: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [

        {
          "@type": "Question",
          "name": "What type of websites can Satima build for my business?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We build different types of websites depending on the needs and goals of your business. This can include business websites, service websites, landing pages, e-commerce websites, portfolio websites, and websites with custom functionality. We focus on creating responsive, professional, and user-friendly websites that provide a strong foundation for your digital presence."
          }
        },

        {
          "@type": "Question",
          "name": "What does a digital marketing strategy involve?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "A digital marketing strategy brings your online marketing activities together around specific business objectives. We look at your target audience, current digital presence, marketing channels, content, advertising opportunities, and overall business goals. This helps create a more structured approach instead of running disconnected marketing activities without a clear direction."
          }
        },

        {
          "@type": "Question",
          "name": "What can Satima do to improve my social media presence?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We help businesses create a more consistent and purposeful social media presence. Our work can include content planning, post creation, publishing, audience engagement, social media strategy, and performance-focused improvements. The objective is not simply to keep your pages active, but to make social media support your wider brand and business goals."
          }
        },

        {
          "@type": "Question",
          "name": "When should my business invest in SEO?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "SEO can be valuable for businesses that want to build sustainable visibility in search engines and attract people who are actively looking for their products or services. It is particularly useful when your business wants to reduce reliance on paid advertising over time and build a stronger organic search presence. We assess your website, industry, competition, and current search visibility before recommending an SEO approach."
          }
        },

        {
          "@type": "Question",
          "name": "Who benefits most from Google Business Profile optimization?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Google Business Profile optimization can be especially valuable for businesses that serve customers within specific locations or depend on local discovery. We help improve important profile elements such as business information, categories, services, descriptions, and other profile details. The goal is to help your business present accurate and useful information when potential customers discover you through Google."
          }
        },

        {
          "@type": "Question",
          "name": "What happens during a digital strategy consultation?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "A digital strategy consultation starts by understanding your business, current digital presence, challenges, and goals. We identify gaps and opportunities across areas such as your website, marketing, SEO, social media, online visibility, and customer journey. From there, we help you identify practical priorities and recommend digital actions that align with your business objectives."
          }
        },

        {
          "@type": "Question",
          "name": "When does a business need a custom software solution?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Custom software can be useful when an existing application or off-the-shelf system cannot properly support the way your business operates. We can develop tailored digital solutions around specific business processes, workflows, data requirements, and operational challenges. The goal is to use technology to solve a real business problem, improve efficiency, and create a solution that can grow with your business."
          }
        }

      ]
    })
  }}
/>    
      </Helmet>
      

{/* PREMIUM ABOUT HERO */}

<section
  className="about-premium-hero"
  style={{
    backgroundImage: `url(${aboutHeroBg})`
  }}
>

  <div className="about-hero-overlay"></div>

  <div className="about-hero-container">

    <div className="about-hero-content">

      <span className="about-hero-tag">
        SATIMA TECHNOVA SOLUTIONS
      </span>

      <h1>
        We Build Digital Growth
        <span> That Matters.</span>
      </h1>

      <p>
        Strategy-led digital solutions for ambitious businesses.
      </p>

      <div className="about-hero-buttons">



<a
  href="https://booking.satimatechnova.co.ke"
  className="hero-btn-secondary"
>
  Book Our Services
</a>


        <Link
          to="/contact"
          className="hero-btn-primary"
        >
          Get Free Consultation
        </Link>

        

      </div>

    </div>

  </div>

</section>

{/* WHO WE ARE SECTION */}

<section className="who-we-are-section">

  <div className="who-container">


{/* LEFT CONTENT */}

<div className="who-content">

  <span className="section-label">
    WHO WE ARE
  </span>

  <h2>
    More Than A Digital Agency
  </h2>

  <p>
    At Satima Technova Solutions, we believe every business deserves a digital presence that works as hard as they do.
  </p>

  <p>
    We partner with SMEs, startups, and growing businesses across Kenya to build strategic digital solutions that attract customers, strengthen brands, and create measurable growth. Our approach brings together strategy, creativity, and technology to ensure every solution has a clear purpose and business impact.
  </p>

</div>


{/* RIGHT CONTENT */}

<div className="who-image-wrapper">

  <img
    src={aboutWhoImg}
    alt="Satima Technova Solutions team working on digital strategy"
    className="who-image"
  />


  {/* STATS CARD */}

  <div className="who-stats-card">

    <div className="stat-item">

      <strong>
        120+
      </strong>

      <span>
        Businesses Supported
      </span>

    </div>


    <div className="stat-item">

      <strong>
        200+
      </strong>

      <span>
        Projects Delivered
      </span>

    </div>


    <div className="stat-item">

      <strong>
        98%
      </strong>

      <span>
        Client Satisfaction
      </span>

    </div>

  </div>

</div>

  </div>

</section>


      
{/* =========================================================
    WHY CHOOSE SATIMA
========================================================= */}

<section className="why-satima-section">

  <div className="why-satima-container">

    <div className="why-section-header">

      <span>
        WHY CHOOSE SATIMA
      </span>

      <h2>
        Digital Solutions
        <br />
        <span>Built With Purpose.</span>
      </h2>

      <p>
        We combine strategic thinking, practical technology, and
        clear communication to build digital solutions around your business.
      </p>

    </div>


    <div className="why-satima-card">

      <div className="why-satima-accent"></div>

      <div className="why-satima-content">


        {/* LEFT STATEMENT */}

        <div className="why-satima-statement">

          <span className="why-satima-quote">
            “
          </span>

          <h3>
            More Than
            <br />
            <span>Digital Services.</span>
          </h3>

        </div>


        {/* RIGHT MESSAGE */}

        <div className="why-satima-message">

          <p>
            We believe the right digital partner should understand
            <strong> your business before building for it.</strong>
            That is why our approach focuses on what matters,
            what should happen next, and how each digital piece
            contributes to the bigger picture.
          </p>


          <div className="why-satima-principles">


            {/* PRINCIPLE 01 */}

            <div className="why-satima-principle">

              <span className="why-satima-number">
                01
              </span>

              <div>

                <h4>
                  Strategy First
                </h4>

                <p>
                  We begin with your business goals, audience,
                  opportunities, and the role digital should play.
                </p>

              </div>

            </div>


            {/* PRINCIPLE 02 */}

            <div className="why-satima-principle">

              <span className="why-satima-number">
                02
              </span>

              <div>

                <h4>
                  Connected Thinking
                </h4>

                <p>
                  Websites, marketing, content, social media,
                  and technology work together as part of one direction.
                </p>

              </div>

            </div>


            {/* PRINCIPLE 03 */}

            <div className="why-satima-principle">

              <span className="why-satima-number">
                03
              </span>

              <div>

                <h4>
                  Built Around You
                </h4>

                <p>
                  Our solutions are shaped around your objectives,
                  resources, audience, and stage of business.
                </p>

              </div>

            </div>


          </div>


          {/* CLOSING STATEMENT */}

          <div className="why-satima-highlight">

            <span className="why-satima-highlight-line"></span>

            <p>
              Good digital work starts with
              <strong> understanding the business behind it.</strong>
            </p>

          </div>


        </div>

      </div>

    </div>

  </div>

</section>


{/* =========================================================
    ABOUT PAGE FAQ SECTION
========================================================= */}

<section className="about-faq-section">


  <div className="about-faq-header">

    <span className="about-faq-label">
      FREQUENTLY ASKED QUESTIONS
    </span>

    <p>
      Explore some of the common questions businesses ask about our
      services and how Satima helps them build stronger digital
      foundations and create opportunities online.
    </p>

  </div>




  <div className="about-faq-container">


    {/* =====================================================
        FAQ 1 — WEBSITE DESIGN & DEVELOPMENT
    ===================================================== */}

    <div className="about-faq-item">

      <details>

        <summary>

          What type of websites can Satima build for my business?

          <FaChevronDown />

        </summary>


        <p>
          We build different types of websites depending on the needs
          and goals of your business.

          <br /><br />

          This can include business websites, service websites,
          landing pages, e-commerce websites, portfolio websites,
          and websites with custom functionality.

          <br /><br />

          We focus on creating responsive, professional, and
          user-friendly websites that provide a strong foundation
          for your digital presence.
        </p>


      </details>

    </div>




    {/* =====================================================
        FAQ 2 — DIGITAL MARKETING
    ===================================================== */}

    <div className="about-faq-item">

      <details>

        <summary>

          What does a digital marketing strategy involve?

          <FaChevronDown />

        </summary>


        <p>
          A digital marketing strategy brings your online marketing
          activities together around specific business objectives.

          <br /><br />

          We look at your target audience, current digital presence,
          marketing channels, content, advertising opportunities,
          and overall business goals.

          <br /><br />

          This helps create a more structured approach instead of
          running disconnected marketing activities without a clear
          direction.
        </p>


      </details>

    </div>




    {/* =====================================================
        FAQ 3 — SOCIAL MEDIA MARKETING
    ===================================================== */}

    <div className="about-faq-item">

      <details>

        <summary>

          What can Satima do to improve my social media presence?

          <FaChevronDown />

        </summary>


        <p>
          We help businesses create a more consistent and purposeful
          social media presence.

          <br /><br />

          Our work can include content planning, post creation,
          publishing, audience engagement, social media strategy,
          and performance-focused improvements.

          <br /><br />

          The objective is not simply to keep your pages active,
          but to make social media support your wider brand and
          business goals.
        </p>


      </details>

    </div>




    {/* =====================================================
        FAQ 4 — SEO
    ===================================================== */}

    <div className="about-faq-item">

      <details>

        <summary>

          When should my business invest in SEO?

          <FaChevronDown />

        </summary>


        <p>
          SEO can be valuable for businesses that want to build
          sustainable visibility in search engines and attract people
          who are actively looking for their products or services.

          <br /><br />

          It is particularly useful when your business wants to reduce
          reliance on paid advertising over time and build a stronger
          organic search presence.

          <br /><br />

          We assess your website, industry, competition, and current
          search visibility before recommending an SEO approach.
        </p>


      </details>

    </div>




    {/* =====================================================
        FAQ 5 — GOOGLE BUSINESS PROFILE
    ===================================================== */}

    <div className="about-faq-item">

      <details>

        <summary>

          Who benefits most from Google Business Profile optimization?

          <FaChevronDown />

        </summary>


        <p>
          Google Business Profile optimization can be especially
          valuable for businesses that serve customers within specific
          locations or depend on local discovery.

          <br /><br />

          We help improve important profile elements such as business
          information, categories, services, descriptions, and other
          profile details.

          <br /><br />

          The goal is to help your business present accurate and useful
          information when potential customers discover you through
          Google.
        </p>


      </details>

    </div>




    {/* =====================================================
        FAQ 6 — DIGITAL STRATEGY & CONSULTATION
    ===================================================== */}

    <div className="about-faq-item">

      <details>

        <summary>

          What happens during a digital strategy consultation?

          <FaChevronDown />

        </summary>


        <p>
          A digital strategy consultation starts by understanding your
          business, current digital presence, challenges, and goals.

          <br /><br />

          We identify gaps and opportunities across areas such as your
          website, marketing, SEO, social media, online visibility,
          and customer journey.

          <br /><br />

          From there, we help you identify practical priorities and
          recommend digital actions that align with your business
          objectives.
        </p>


      </details>

    </div>




    {/* =====================================================
        FAQ 7 — CUSTOM SOFTWARE SOLUTIONS
    ===================================================== */}

    <div className="about-faq-item">

      <details>

        <summary>

          When does a business need a custom software solution?

          <FaChevronDown />

        </summary>


        <p>
          Custom software can be useful when an existing application
          or off-the-shelf system cannot properly support the way your
          business operates.

          <br /><br />

          We can develop tailored digital solutions around specific
          business processes, workflows, data requirements, and
          operational challenges.

          <br /><br />

          The goal is to use technology to solve a real business
          problem, improve efficiency, and create a solution that can
          grow with your business.
        </p>


      </details>

    </div>


  </div>


</section>



{/* FINAL CTA SECTION */}

<section className="about-final-cta">

  <div className="about-final-cta-inner">

    <span className="about-final-cta-label">
      PARTNER WITH SATIMA TECHNOVA
    </span>

    <h2>
      Build A Digital
      <br />
      <span>Future With Direction.</span>
    </h2>

    <p>
      Let's create the strategy, technology, and digital presence
      your business needs to move forward with confidence.
    </p>

    <a
      href="/contact"
      className="about-final-cta-btn"
    >
      Start A Conversation
      <span>→</span>
    </a>

  </div>

</section>



    </>
  );
};

export default About;